import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckIcon, ChevronDownIcon, TrophyIcon } from 'lucide-react';
import { tomoIncludes, tomos } from '../data/content';
import { Button } from './ui/Button';
import { Eyebrow, SectionTitle } from './ui/SectionHeading';
const values = ['540+ páginas de material', '6 Tomos completos', 'Inicial → Avanzado', 'Los 4 aparatos cubiertos', 'Clases listas para aplicar', 'Adaptado para Argentina'];
export function ProductOverview() {
  const [open, setOpen] = useState(0);
  return <section className="mx-auto max-w-5xl px-4 py-12 md:py-16" data-id="element-272" data-mp="1tnfainul9b9t">
      <Eyebrow data-id="element-273" data-mp="1omhtwfp88paf">
        <span className="inline-flex items-center gap-2" data-id="element-274" data-mp="1oo2d5963clsz">
          <TrophyIcon aria-hidden="true" className="h-4 w-4" data-id="element-275" data-mp="1jny76d2t79h0" /> Combo Completo Gimnasia Artística
          2026
        </span>
      </Eyebrow>
      <SectionTitle data-id="element-276" data-mp="3ixwksztz4urr">
        6 Tomos + 6 Bonos. <span className="text-gold" data-id="element-277" data-mp="3e0ebh8c1odj8">Todo resuelto.</span>
      </SectionTitle>
      <p className="mt-4 text-center font-medium text-zinc-400" data-id="element-278" data-mp="10dht11pwc8m8">
        Del primer rodamiento al año competitivo planificado. Listo para aplicar hoy.
      </p>

      <ul className="mt-10 grid grid-cols-2 gap-3 md:grid-cols-3" data-id="element-279" data-mp="15e5tee00m1t4">
        {values.map(value => <li key={value} className="flex items-center gap-3 rounded-xl border border-line bg-surface p-4" data-id="element-280" data-mp="qgvdmsgca9rl">
            <span aria-hidden="true" className="rounded-lg bg-gold/15 p-2" data-id="element-281" data-mp="1j49cwx7ifhev">
              <CheckIcon className="h-4 w-4 text-gold" data-id="element-282" data-mp="1j6bzt8dd8ufd" />
            </span>
            <span className="text-sm font-bold leading-tight text-white" data-id="element-283" data-mp="1o2j46wq45xv7">{value}</span>
          </li>)}
      </ul>

      <div className="mt-16" data-id="element-284" data-mp="19cby7gham7be">
        <h3 className="mx-auto max-w-3xl text-center text-2xl font-black leading-tight text-white md:text-4xl" data-id="element-285" data-mp="1ecr8u0a6x0po">
          6 tomos para <span className="text-gold" data-id="element-286" data-mp="22222kxt4huub">dar cualquier clase con confianza.</span>
        </h3>
        <p className="mt-3 text-center text-sm font-medium text-zinc-500" data-id="element-287" data-mp="26ulrgqx9gcef">
          Tocá un tomo para ver el contenido
        </p>
        <div className="mt-8 space-y-3" data-id="element-288" data-mp="2gorbfq99lkdd">
          {tomos.map((tomo, index) => {
          const isOpen = open === index;
          return <div key={tomo.name} className={`overflow-hidden rounded-2xl border bg-surface transition-colors duration-150 ease-smooth ${isOpen ? 'border-gold' : 'border-line'}`} data-id="element-289" data-mp="27ocnej4x1r66" data-mpi={index}>
                <button type="button" className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left md:px-7 md:py-5" aria-expanded={isOpen} onClick={() => setOpen(isOpen ? -1 : index)} data-id="element-290" data-mp="1xsj48gwoyzff">
                  <span className="flex items-center gap-3" data-id="element-291" data-mp="1jx6zdgotnsks">
                    <span aria-hidden="true" className="text-2xl" data-id="element-292" data-mp="1ez5fwunhhr8s">
                      {tomo.icon}
                    </span>
                    <span data-id="element-293" data-mp="1a1vrnibtzlmj">
                      <b className="block text-white" data-id="element-294" data-mp="3lofsdden7s0b">
                        Tomo {index + 1} — {tomo.name}
                      </b>
                      <small className="font-bold text-gold" data-id="element-295" data-mp="3qmhcm1nt1xdd">{tomo.period}</small>
                    </span>
                  </span>
                  <ChevronDownIcon aria-hidden="true" className={`h-5 w-5 shrink-0 text-gold transition-transform duration-200 ease-smooth ${isOpen ? 'rotate-180' : ''}`} data-id="element-296" data-mp="3vneqi21s8592" />
                </button>
                <AnimatePresence initial={false} data-id="element-297" data-mp="37xao1y0bybjn">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-298" data-mp="3bx31ao0o55vc">
                      <ul className="space-y-2 border-t border-line px-5 py-4 text-sm font-medium text-zinc-400 md:px-7" data-id="element-299" data-mp="2o78qebzwtrdq">
                        {tomo.content.map(line => <li key={line} className="flex gap-2" data-id="element-300" data-mp="206ojtzarmk27">
                            <span aria-hidden="true" className="text-gold" data-id="element-301" data-mp="2etzyia28uk6j">
                              →
                            </span>
                            {line}
                          </li>)}
                      </ul>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>

        <div className="mt-10 rounded-3xl border border-gold/25 bg-surface p-6 md:p-8" data-id="element-302" data-mp="2xtnksm8hqe5w">
          <h4 className="text-center text-lg font-black uppercase tracking-wide text-gold md:text-xl" data-id="element-303" data-mp="2suamn5c65ko0">
            Cada tomo incluye
          </h4>
          <ul className="mt-6 grid gap-3 sm:grid-cols-2 lg:grid-cols-3" data-id="element-304" data-mp="13fmni5sl9z7x">
            {tomoIncludes.map(item => <li key={item} className="flex items-start gap-2 text-sm font-medium text-zinc-300" data-id="element-305" data-mp="yhun0ndvp4s4">
                <CheckIcon aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-gold" data-id="element-306" data-mp="3a5g85djlja0a" />
                {item}
              </li>)}
          </ul>
          <div className="mt-8 text-center" data-id="element-307" data-mp="30cimiyjb54xg">
            <Button href="#pricing" className="w-full text-sm md:w-auto md:text-base" data-id="element-308" data-mp="30bpmegeutdoa">
              Sí, quiero los 6 tomos completos →
            </Button>
          </div>
        </div>
      </div>
    </section>;
}